import SplunkOtelWeb from '@splunk/otel-web';
import { getEnvironmentFromHost } from '@ace-clublabs/log-cannon';
import { splunkRUM } from './utils/constants';

const getAppVersionFromMeta = () => {
  return document?.querySelector('meta[name="version"]')?.getAttribute('content') || 'unknown-version';
};
SplunkOtelWeb.init({
  applicationName: splunkRUM.SPLUNK_APP_NAME,
  deploymentEnvironment: getEnvironmentFromHost(),
  realm: splunkRUM.SPLUNK_REALM,
  rumAccessToken: splunkRUM.SPLUNK_RUM_AUTH,
  version: getAppVersionFromMeta(),
});
